<template>
  <div id="contenedor-editar-catalogo-tipo-documento">
    <v-form v-model="formularioValido" ref="actualizarTipoDocumento">
      <v-card>
        <v-card-title class="secondary--text">
          Editar tipo de documento
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Descripción"
            v-model="tipoDocumento.descripcion"
            v-on:keypress.enter="mixActualizarCatalogoTipoDocumento"
          >
          </custom-text-field>
          <custom-text-field
            label="Orden"
            v-model.number="tipoDocumento.orden"
            v-on:keypress.enter="mixActualizarCatalogoTipoDocumento"
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarCatalogoTipoDocumento"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoTiposDocumentos from './mixCatalogoTiposDocumentos';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogoTipoDocumentoEditar',
  mixins: [mixCatalogoTiposDocumentos],
  props: {
    tipoDocumentoEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tipoDocumento: {
        descripcion: this.tipoDocumentoEditar.descripcion,
        orden: this.tipoDocumentoEditar.orden,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.actualizarTipoDocumento.reset();
    },
  },
};
</script>

<style>
</style>
